import { StrategyBuilderParams, SHORT, CALL, LONG, PUT } from './types';

type BaseBuilderParams = Omit<StrategyBuilderParams, 'type' | 'position'>;

export const addOption = (params: StrategyBuilderParams) => params;

export const addLongCall = (params: BaseBuilderParams) => {
  return addOption({
    ...params,
    type: CALL,
    position: LONG,
  });
};

export const addShortCall = (params: BaseBuilderParams) => {
  return addOption({
    ...params,
    numberOfContracts: -1 * params.numberOfContracts,
    type: CALL,
    position: SHORT,
  });
};

export const addLongPut = (params: BaseBuilderParams) => {
  return addOption({
    ...params,
    type: PUT,
    position: LONG,
  });
};

export const addShortPut = (params: BaseBuilderParams) => {
  return addOption({
    ...params,
    numberOfContracts: -1 * params.numberOfContracts,
    type: PUT,
    position: SHORT,
  });
};
